import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import registryToast from './toast'
import VueWechatTitle from 'vue-wechat-title'//动态修改浏览器页面title
Vue.use(VueWechatTitle)
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
import MessageTree from './message_tree' // 评论回复树组件
// import MessageTree from './lib/message-tree.umd.min.js'
Vue.use(MessageTree)
// 富文本编辑器 github主题
import VMdEditor from '@kangc/v-md-editor';
import '@kangc/v-md-editor/lib/style/base-editor.css';
import VMdPreview from '@kangc/v-md-editor/lib/preview';
import '@kangc/v-md-editor/lib/style/preview.css';
import githubTheme from '@kangc/v-md-editor/lib/theme/github.js';
import '@kangc/v-md-editor/lib/theme/style/github.css';
import hljs from 'highlight.js';
VMdEditor.use(githubTheme, {
  Hljs: hljs,
});
VMdPreview.use(githubTheme, {
  Hljs: hljs,
});
Vue.use(VMdEditor);
Vue.use(VMdPreview);


Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$long_judge_sentence = function(username_github) {
  return !$cookies.isKey('username_github')?(username_github=='tourist'?false:true):(username_github!=$cookies.get('username_github')&&username_github!='tourist'?true:false)
};
// 用于判断是否为管理员的全局方法
Vue.prototype.$is_admin = function(username_github) {
  var admin = ["InferiorCoder", "fishfish-yu", "talin0x1"]
  if(admin.indexOf(username_github) > -1){
    return true
  }
  else{
    return false
  }
}

Vue.use(registryToast)
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
  watch: {
    $route: {
      handler: function(val, oldval) {
        // console.log(val.path);
      },
      deep: true
    }
  },
  methods: {

}
}).$mount('#app')
